/**
 * Comma-separated multi-role parsing utilities for Gamiteam Admin Portal.
 * Supports single roles ('owner', 'maker', 'superadmin') and multi-roles ('owner,player', 'maker,player').
 */

export const ADMIN_PORTAL_ROLES = ['superadmin', 'owner', 'maker'];

export function parseRoles(roleInput) {
  if (!roleInput) return [];
  if (Array.isArray(roleInput)) {
    return roleInput
      .map((r) => String(r || '').trim().toLowerCase())
      .filter(Boolean);
  }
  if (typeof roleInput === 'object') {
    const raw = roleInput?.data?.role ?? roleInput?.role ?? '';
    return parseRoles(raw);
  }
  return String(roleInput)
    .split(',')
    .map((r) => r.trim().toLowerCase())
    .filter(Boolean);
}

export function hasRole(roleInput, targetRole) {
  if (!targetRole) return false;
  return parseRoles(roleInput).includes(String(targetRole).trim().toLowerCase());
}

export function hasAnyRole(roleInput, targetRoles = []) {
  const roles = parseRoles(roleInput);
  return targetRoles.some((r) => roles.includes(String(r).trim().toLowerCase()));
}

export function hasAdminPortalAccess(roleInput) {
  return hasAnyRole(roleInput, ADMIN_PORTAL_ROLES);
}

export function isPurePlayer(roleInput) {
  const roles = parseRoles(roleInput);
  return roles.includes('player') && !hasAdminPortalAccess(roles);
}
